import styled, { keyframes } from 'styled-components';
import { ReactComponent as AreaGraphEmptyState } from 'images/widgets/area-graph-empty.svg';
import { ReactComponent as BarGraphEmptyState } from 'images/widgets/bar-graph-empty.svg';
import { GRAPH_TYPES } from '../../../consts/graphTypes';

const loadingAnimation = keyframes`
    0% {
        opacity: 0.55;
    }
    100% {
        opacity: 1;
    }
`;

const StyledAreaGraphEmptyState = styled(AreaGraphEmptyState)`
  width: 100%;
  height: 100%;
  animation: ${loadingAnimation} 1s infinite alternate;
`;

const StyledBarGraphEmptyState = styled(BarGraphEmptyState)`
  width: 100%;
  height: 100%;
  animation: ${loadingAnimation} 1s infinite alternate;
`;
const getSkeltonByGraphType = graphType => {
  const graphsByType = {
    [GRAPH_TYPES.BAR]: StyledBarGraphEmptyState,
    [GRAPH_TYPES.AREA_SPLINE]: StyledAreaGraphEmptyState,
    [GRAPH_TYPES.STACKED]: StyledBarGraphEmptyState,
    default: StyledAreaGraphEmptyState
  };
  return graphsByType[graphType] ?? graphsByType.default;
};

export default getSkeltonByGraphType;
